module.exports = __webpack_public_path__ + "static/img/wisdom2.2c5317e7.png";